import { CustomerPaymentMethod } from '../../../modules/store/profileStore';
import { SavedCard } from '../../../modules/store/savedCardsStore';

export type WalletPaymentMethod = Partial<CustomerPaymentMethod> & Partial<SavedCard>;

const formatExpiryDate = (expiration?: CustomerPaymentMethod['expiration']): string | undefined => {
  if (!expiration?.month || !expiration?.year) {
    return undefined;
  }

  const month = String(expiration.month).padStart(2, '0');
  const year = String(expiration.year).slice(-2);
  return `${month}/${year}`;
};

export const mapWalletPaymentMethodToSavedCard = (method: WalletPaymentMethod): SavedCard => ({
  id: method.id ?? '',
  cardNumber: method.panLast4 ?? method.cardNumber ?? '',
  cardholderName: method.nickname ?? method.cardholderName ?? '',
  cardType: method.issuerType?.code ?? method.cobrand?.issuer?.code ?? method.cardType ?? '',
  expiryDate: formatExpiryDate(method.expiration) ?? method.expiryDate ?? '',
  isPrimary: method.preferred ?? method.isPrimary ?? false,
  cardStatus: method.cardStatus,
  issuerProductCode: method.cobrand?.issuerProduct?.code,
});
